import React from "react";

import {
  Clear,
  Done,
  HourglassEmpty as HourglassEmptyIcon,
} from "@mui/icons-material";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";

import Badge, { BadgeProps } from "@/extensions/klarahill/components/Badge";
import { AdStatus } from "@/extensions/obituary/types";
import { statusLabels } from "@/extensions/obituary/utils/statusLabels";
const statusIcon: Record<AdStatus, React.FC<{ fontSize: "small" }>> = {
  rejected: Clear,
  pending_mediahouse_review: HourglassEmptyIcon,
  customer_approved: Done,
  draft: ModeEditOutlineOutlinedIcon,
  sent: Done,
  archived: Inventory2OutlinedIcon,
  cancelled: Clear,
  pending_cancellation_review: HourglassEmptyIcon,
} as const;

export const statusColor: Record<AdStatus, Readonly<[string, string]>> = {
  rejected: ["#FFFAC3", "#F47F19"],
  pending_mediahouse_review: ["#BBDEFB", "#1976D2"],
  customer_approved: ["#C8E6C9", "#388E3C"],
  draft: ["#E0E0E0", "#616161"],
  sent: ["#C8E6C9", "#388E3C"],
  archived: ["#E0E0E0", "#616161"],
  cancelled: ["#FFCDD2", "#B71C1C"],
  pending_cancellation_review: ["#BBDEFB", "#1976D2"],
} as const;

export interface AdStatusBadgeProps extends Omit<BadgeProps, "icon"> {
  status: AdStatus;
}

const AdStatusBadge: React.FC<AdStatusBadgeProps> = ({ status, ...props }) => {
  const [background, foreground] = statusColor[status];
  const label = statusLabels[status];
  const Icon = statusIcon[status];

  return (
    <Badge
      backgroundColor={background}
      foregroundColor={foreground}
      icon={<Icon fontSize="small" />}
      label={label}
      {...props}
    />
  );
};

export default AdStatusBadge;
